(function () {
  const products = document.querySelectorAll('[data-fd-product]');
  if (!products.length) return;

  const targetBcpoMainImageLinkHandles = new Set([
    'outdoor-curtain-custom-linen-curtains-chevrons',
    'sheer-cafe-curtains-for-small-windows',
    'sheer-cafe-curtains-for-white-kitchen',
    'custom-linen-curtains-bolonia',
    'heavy-duty-long-curtains-for-bathroom-showers-bolonia',
    'modern-curtains-for-bedroom-bolonia',
    'outdoor-curtain-bedroom-window-curtains-bolonia',
    'room-divider-curtain-bedroom-window-curtains-bolonia',
    'window-shades-for-baby-room-dp60-01-23',
    'velvet-christmas-kitchen-curtains-for-holiday',
    'velvet-kitchen-window-cafe-curtains',
    'outdoor-curtain-sliding-patio-door-curtains-hundred'
  ]);

  const handleize = (value) => String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const uniqueKeys = (keys) => {
    const seen = new Set();
    return keys
      .map((key) => String(key || '').trim())
      .filter((key) => {
        if (!key || seen.has(key)) return false;
        seen.add(key);
        return true;
      });
  };

  const getColorCodeKeys = (value) => {
    const text = String(value || '');
    const keys = [];
    const matcher = /#?\b([a-z]{1,5}\d{2,5})(?:[-_\s]*(\d{1,2}))?\b/gi;
    let match = matcher.exec(text);
    while (match) {
      const family = String(match[1] || '').toUpperCase();
      const suffix = match[2] ? `-${Number(match[2])}` : '';
      const code = `${family}${suffix}`;
      keys.push(`#${code}`, code, code.toLowerCase(), handleize(code));
      match = matcher.exec(text);
    }
    return uniqueKeys(keys);
  };

  const cleanGeneratedColorKey = (value) => String(value || '')
    .replace(/[-_]+/g, ' ')
    .replace(/\s*\(\s*$/, '')
    .replace(/\s+/g, ' ')
    .trim();

  const getLabelKeyCandidates = (value) => {
    const text = String(value || '').trim();
    if (!text) return [];
    const withoutHash = text.replace(/^#/, '');
    const withoutColorCode = cleanGeneratedColorKey(text.replace(/\s*\([^)]*#?[a-z]{1,5}\d{2,5}[^)]*\)\s*$/i, ''));
    const keys = [
      text,
      text.toLowerCase(),
      handleize(text),
      withoutHash,
      withoutHash.toLowerCase(),
      handleize(withoutHash),
      withoutColorCode,
      withoutColorCode.toLowerCase(),
      handleize(withoutColorCode),
      ...getColorCodeKeys(text)
    ];
    return uniqueKeys(keys);
  };

  const findImageByLabel = (map, label) => {
    const candidates = getLabelKeyCandidates(label);
    for (const candidate of candidates) {
      const image = map.get(candidate);
      if (image) return image;
    }
    return '';
  };

  const isBrandedJ401SwatchMedia = (src) => {
    const value = String(src || '').toLowerCase();
    if (!value) return false;
    return value.includes('/fredesigner-')
      && value.includes('-j401-')
      && value.includes('.png');
  };

  const getVariantOptions = (variant) => {
    if (Array.isArray(variant.options)) return variant.options;
    return [variant.option1, variant.option2, variant.option3].filter(Boolean);
  };

  const formatMoney = (cents) => {
    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      return window.theme.Currency.formatMoney(cents, window.theme.settings && window.theme.settings.moneyFormat);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return `$${(Number(cents || 0) / 100).toFixed(2)} USD`;
  };

  const expandBcpoImageUrl = (src) => {
    const value = String(src || '');
    if (!value || typeof window.atob !== 'function' || typeof window.btoa !== 'function') return value;

    try {
      const url = new URL(value, window.location.href);
      if (!url.hostname.includes('d17fzo7x83uajt.cloudfront.net')) return value;
      const payload = JSON.parse(window.atob(url.pathname.replace(/^\//, '')));
      payload.edits = payload.edits || {};
      payload.edits.resize = payload.edits.resize || {};
      payload.edits.resize.width = Math.max(Number(payload.edits.resize.width || 0), 1200);
      return `${url.origin}/${window.btoa(JSON.stringify(payload))}`;
    } catch (error) {
      return value;
    }
  };

  const getImageFileName = (src) => {
    const value = expandBcpoImageUrl(src);
    if (!value) return '';
    try {
      const url = new URL(value, window.location.href);
      return decodeURIComponent(url.pathname.split('/').pop() || '').toLowerCase();
    } catch (error) {
      return String(value).split('?')[0].split('/').pop().toLowerCase();
    }
  };

  const addColorImageKey = (map, key, src, replaceExisting) => {
    const value = String(key || '').trim();
    if (!value || !src) return;
    const imageSrc = expandBcpoImageUrl(src);
    const withoutHash = value.replace(/^#/, '');
    const withoutStyleCode = withoutHash
      .replace(/^style#?\d+[-\s]*\d*\s*/i, '')
      .replace(/^[a-z]{1,5}\d{0,4}[-\s]*\d+\s*/i, '')
      .trim();
    const withoutColorSuffix = withoutStyleCode.replace(/\s+color$/i, '').trim();
    [value, value.toLowerCase(), handleize(value), withoutHash, withoutHash.toLowerCase(), handleize(withoutHash), withoutStyleCode, withoutStyleCode.toLowerCase(), handleize(withoutStyleCode), withoutColorSuffix, withoutColorSuffix.toLowerCase(), handleize(withoutColorSuffix), ...getColorCodeKeys(value)]
      .filter(Boolean)
      .forEach((item) => {
        if (replaceExisting || !map.has(item)) map.set(item, imageSrc);
      });
  };

  const getGeneratedMediaColorKey = (value) => {
    const text = String(value || '').trim();
    if (!text) return '';
    const altMatch = text.match(/\s-\s(.+?)\s+browser generated product photo/i);
    if (altMatch) return altMatch[1].trim();
    const optionAltMatch = text.match(/\bcolor option\s+(.+?)(?:\s+by\s+fredesigner\b|$)/i);
    if (optionAltMatch) return cleanGeneratedColorKey(optionAltMatch[1]);
    const colorCode = getColorCodeKeys(text)[0];
    if (colorCode) return colorCode;
    return text
      .replace(/-?browser-generated-product-photo$/i, '')
      .replace(/\s+browser generated product photo$/i, '')
      .trim();
  };

  products.forEach((root) => {
    const productHandle = String(root.dataset.productHandle || '').trim();
    const preferBcpoColorImageAsMain = targetBcpoMainImageLinkHandles.has(productHandle);
    const targetBcpoMainImageState = { src: '', alt: '', correcting: false };
    const variantJson = root.querySelector('[data-fd-variants-json]');
    let variants = [];
    try {
      variants = JSON.parse(variantJson ? variantJson.textContent : '[]');
    } catch (error) {
      variants = [];
    }

    const form = root.querySelector('.fd-pdp-form');
    const variantInput = root.querySelector('[data-fd-variant-id]');
    const price = root.querySelector('[data-fd-price]');
    const stickyPrice = root.querySelector('[data-fd-sticky-price]');
    const comparePrice = root.querySelector('[data-fd-compare-price]');
    const atc = root.querySelector('[data-fd-atc]');
    const atcText = root.querySelector('[data-fd-atc-text]');
    const mainImage = root.querySelector('[data-fd-main-image]');
    const mainImageFrame = mainImage ? mainImage.closest('.fd-pdp__main-image') : null;
    const colorProperty = root.querySelector('[data-fd-color-property]');
    const thumbs = Array.from(root.querySelectorAll('[data-fd-thumb]'));
    const quantityInput = root.querySelector('[data-fd-quantity]');
    const cordedBlocks = Array.from(root.querySelectorAll('[data-fd-corded-only]'));
    const selectedOptions = [];

    const installJennaBcpoPriceFallback = () => {
      const targetHandles = new Set([
        'custom-light-filtering-roman-shade',
        'custom-white-linen-plain-fold-roman-shade',
        'custom-textured-sheer-roman-shade'
      ]);
      const targetProductIds = new Set(['9238055649530', '9238055780602', '9238055059706']);
      const productHandle = String(root.dataset.productHandle || '').trim();
      const isTarget = () => {
        const data = window.bcpo_data || {};
        return targetHandles.has(productHandle) || targetProductIds.has(String(data.product_id || ''));
      };
      if (!isTarget()) return null;

      const normalizeOptionText = (value) => String(value || '')
        .replace(/\s+\|\s*[-+]?[$€£]?\s*[\d,.]+.*$/i, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
      const parseAddonPrice = (value) => {
        const number = Number(String(value || '').replace(/[^-\d.]/g, ''));
        return Number.isFinite(number) ? number : 0;
      };
      const optionTitleFromControl = (control) => {
        const match = String(control && control.name ? control.name : '').match(/^properties\[(.+)\]$/);
        if (match) return match[1];
        const wrapper = control && control.closest ? control.closest('#bcpo .selector-wrapper') : null;
        const label = wrapper && (wrapper.querySelector('.bcpo-label, .bcpo-title, label') || wrapper);
        return label ? label.textContent : '';
      };
      const getBcpoOptions = () => {
        const data = window.bcpo_data || {};
        return Array.isArray(data.virtual_options) ? data.virtual_options : [];
      };
      const findBcpoValue = (title, value) => {
        const option = getBcpoOptions().find((item) => normalizeOptionText(item && item.title) === normalizeOptionText(title));
        if (!option || !Array.isArray(option.values)) return null;
        const wanted = normalizeOptionText(value);
        return option.values.find((item) => normalizeOptionText(item && item.key) === wanted) ||
          option.values.find((item) => normalizeOptionText(item && item.key).includes(wanted) || wanted.includes(normalizeOptionText(item && item.key))) ||
          null;
      };
      const getSelectedValue = (control) => {
        if (!control) return '';
        if (control.tagName === 'SELECT') {
          const selected = control.options && control.selectedIndex >= 0 ? control.options[control.selectedIndex] : null;
          return selected ? (selected.value || selected.textContent) : control.value;
        }
        return control.value;
      };
      const getSelectedControls = () => Array.from(document.querySelectorAll('#bcpo input:checked, #bcpo select, #bcpo textarea'))
        .filter((control) => !control.disabled && !control.closest('[hidden], .fd-bcpo-template-hidden, .fd-bcpo-force-hidden, [aria-hidden="true"]'));
      const getBaseVariantPrice = () => {
        const currentId = variantInput ? String(variantInput.value || '') : '';
        const variant = variants.find((item) => String(item.id) === currentId) || variants[0] || {};
        return Number(variant.price || 0);
      };
      const getAddonTotalCents = () => getSelectedControls().reduce((sum, control) => {
        const match = findBcpoValue(optionTitleFromControl(control), getSelectedValue(control));
        const priceValue = parseAddonPrice(match && match.price);
        return sum + Math.round(priceValue * 100);
      }, 0);
      const updateDisplay = () => {
        const total = getBaseVariantPrice() + getAddonTotalCents();
        if (price) price.textContent = formatMoney(total);
        if (stickyPrice) stickyPrice.textContent = formatMoney(total);
      };
      const prepareProperties = () => {
        if (window.bcpo && window.bcpo.$) return;
        getSelectedControls().forEach((control) => {
          if (!control || control.tagName === 'TEXTAREA' || String(control.type || '').toLowerCase() === 'file') return;
          const match = findBcpoValue(optionTitleFromControl(control), getSelectedValue(control));
          const priceValue = parseAddonPrice(match && match.price);
          if (!priceValue) return;
          const baseValue = String(getSelectedValue(control) || '').replace(/\s+\|\s*[-+]?[$€£]?\s*[\d,.]+.*$/i, '').trim();
          const suffixedValue = `${baseValue} | $${priceValue.toFixed(2)}`;
          if (control.tagName === 'SELECT') {
            const selected = control.options && control.selectedIndex >= 0 ? control.options[control.selectedIndex] : null;
            if (selected) selected.value = suffixedValue;
          } else {
            control.value = suffixedValue;
          }
        });
      };

      if (form) form.addEventListener('submit', prepareProperties, true);
      root.addEventListener('click', (event) => {
        const target = event.target && event.target.closest ? event.target : null;
        if (target && target.closest('[data-fd-atc], [data-fd-sticky-submit]')) prepareProperties();
        window.setTimeout(updateDisplay, 40);
      }, true);
      root.addEventListener('change', () => window.setTimeout(updateDisplay, 40), true);
      root.addEventListener('input', () => window.setTimeout(updateDisplay, 40), true);
      window.setTimeout(updateDisplay, 800);
      window.setTimeout(updateDisplay, 1800);
      return { updateDisplay, prepareProperties };
    };

    const jennaBcpoPriceFallback = installJennaBcpoPriceFallback();

    root.querySelectorAll('[data-fd-option-position]').forEach((group) => {
      const position = Number(group.dataset.fdOptionPosition || '1') - 1;
      const selected = group.querySelector('[data-fd-option-value].is-selected') || group.querySelector('[data-fd-option-value]');
      selectedOptions[position] = selected ? selected.dataset.optionValue : '';
    });

    const colorImageMap = new Map();
    const productColorImageMap = new Map();
    thumbs.forEach((thumb) => {
      if (isBrandedJ401SwatchMedia(thumb.dataset.full)) return;
      addColorImageKey(productColorImageMap, thumb.dataset.alt, thumb.dataset.full);
      addColorImageKey(productColorImageMap, getGeneratedMediaColorKey(thumb.dataset.alt), thumb.dataset.full, true);
      addColorImageKey(productColorImageMap, getGeneratedMediaColorKey(thumb.dataset.group), thumb.dataset.full, true);
    });

    const refreshThemeColorImages = () => {
      const themeMapJson = root.querySelector('[data-fd-theme-color-images]');
      if (!themeMapJson) return;
      let themeMap = {};
      try {
        themeMap = JSON.parse(themeMapJson.textContent || '{}');
      } catch (error) {
        themeMap = {};
      }

      Object.keys(themeMap).forEach((key) => {
        addColorImageKey(colorImageMap, key, themeMap[key], true);
      });
    };

    const refreshBcpoColorImages = () => {
      const sources = [];
      const bcpoData = window.bcpo_data;
      const bcpoProduct = window.bcpo_product;
      if (bcpoData && Array.isArray(bcpoData.virtual_options)) sources.push(bcpoData.virtual_options);
      if (bcpoProduct && Array.isArray(bcpoProduct.options)) sources.push(bcpoProduct.options);

      sources.forEach((options) => {
        options.forEach((option) => {
          const title = String(option && option.title ? option.title : '').toLowerCase();
          const type = String(option && option.type ? option.type : '').toLowerCase();
          if (type !== 'images' || !title.includes('color') || !Array.isArray(option.values)) return;
          option.values.forEach((item) => addColorImageKey(colorImageMap, item && item.key, item && item.value));
        });
      });
    };

    refreshBcpoColorImages();
    refreshThemeColorImages();

    const getBcpoColorOptionIndexes = () => {
      const indexes = new Set();
      const sources = [];
      const bcpoData = window.bcpo_data;
      const bcpoProduct = window.bcpo_product;
      if (bcpoData && Array.isArray(bcpoData.virtual_options)) sources.push(bcpoData.virtual_options);
      if (bcpoProduct && Array.isArray(bcpoProduct.options)) sources.push(bcpoProduct.options);

      sources.forEach((options) => {
        options.forEach((option, index) => {
          const title = String(option && option.title ? option.title : '').toLowerCase();
          const type = String(option && option.type ? option.type : '').toLowerCase();
          if (type === 'images' && (title.includes('color') || title.includes('colour') || title.includes('fabric'))) {
            indexes.add(index);
          }
        });
      });

      return indexes;
    };

    const getColorImage = (label) => {
      refreshBcpoColorImages();
      refreshThemeColorImages();
      return findImageByLabel(colorImageMap, label);
    };

    const getProductColorImage = (label) => {
      return findImageByLabel(productColorImageMap, label);
    };

    const getCssBackgroundUrl = (element) => {
      if (!element || !window.getComputedStyle) return '';
      const background = window.getComputedStyle(element).backgroundImage || '';
      const match = background.match(/url\(["']?([^"')]+)["']?\)/);
      return match ? match[1] : '';
    };

    const isSceneColorSwatchImage = (src) => {
      const value = String(src || '').toLowerCase();
      return value.includes('roman-shade-color-')
        || value.includes('custom-roman-shade-color')
        || value.includes('relaxed-custom-roman-shade-color')
        || value.includes('cafe-curtain')
        || value.includes('cafe-style');
    };

    const canUseSwatchImageAsMain = (src) => {
      const value = String(src || '').toLowerCase();
      if (!value || value.includes('d17fzo7x83uajt.cloudfront.net')) return false;
      return isSceneColorSwatchImage(value);
    };

    const isBcpoColorTitle = (value) => {
      const title = String(value || '').toLowerCase();
      return title.includes('color') || title.includes('colour') || title.includes('fabric');
    };

    const getBcpoWrapperTitle = (wrapper) => {
      if (!wrapper) return '';
      const titleLabel = wrapper.querySelector('.bcpo-title, .bcpo-label label') || Array.from(wrapper.children || []).find((child) => child.tagName === 'LABEL');
      return titleLabel ? titleLabel.textContent : (wrapper.getAttribute('data-title') || wrapper.getAttribute('aria-label') || '');
    };

    const getBcpoWrapperIndex = (wrapper) => {
      const dataOption = wrapper ? (wrapper.getAttribute('data-option') || '') : '';
      const dataOptionMatch = dataOption.match(/^option(\d+)$/);
      return dataOptionMatch ? Number(dataOptionMatch[1]) - 1 : -1;
    };

    const isBcpoColorWrapper = (wrapper, colorIndexes) => {
      if (!wrapper) return false;
      if (isBcpoColorTitle(getBcpoWrapperTitle(wrapper))) return true;
      if (isColorInputName(wrapper.querySelector('input, select'))) return true;
      const index = getBcpoWrapperIndex(wrapper);
      return index >= 0 && colorIndexes.has(index);
    };

    const applyBcpoChoiceImage = (element, src) => {
      if (!element || !src) return;
      const imageSrc = expandBcpoImageUrl(src);
      const useSceneCrop = isSceneColorSwatchImage(imageSrc);
      const useFabricOnlyCrop = !useSceneCrop
        && imageSrc.toLowerCase().includes('fredesigner-')
        && imageSrc.toLowerCase().includes('j401-');
      element.style.backgroundImage = `url("${imageSrc.replace(/"/g, '\\"')}")`;
      element.style.backgroundRepeat = 'no-repeat';
      const backgroundPosition = useSceneCrop ? '50% 35%' : (useFabricOnlyCrop ? '50% 14%' : 'center');
      const backgroundSize = useSceneCrop ? '260% 260%' : (useFabricOnlyCrop ? '180% 180%' : 'cover');
      if (element.style.setProperty) {
        element.style.setProperty('background-position', backgroundPosition, 'important');
        element.style.setProperty('background-size', backgroundSize, 'important');
      } else {
        element.style.backgroundPosition = backgroundPosition;
        element.style.backgroundSize = backgroundSize;
      }
      element.classList.toggle('fd-bcpo-scene-color-label', useSceneCrop);
      element.classList.toggle('fd-bcpo-fabric-only-color-label', useFabricOnlyCrop);
      const parent = element.closest && element.closest('#bcpo .bcpo-image-parent, #bcpo .bcpo-color-parent');
      if (parent) parent.classList.toggle('fd-bcpo-scene-color-choice', useSceneCrop);
      if (parent) parent.classList.toggle('fd-bcpo-fabric-only-color-choice', useFabricOnlyCrop);
    };

    root.querySelectorAll('[data-fd-media-swatch]').forEach((swatch) => {
      if (swatch.dataset.image) return;
      const swatchImage = getColorImage(swatch.dataset.label || swatch.dataset.alt);
      if (swatchImage) swatch.dataset.image = swatchImage;
    });

    const setMainImage = (src, alt) => {
      if (!mainImage || !src) return;
      const normalizedSrc = expandBcpoImageUrl(src);
      if (mainImage.getAttribute('src') === normalizedSrc) return;
      mainImage.style.opacity = '0';
      mainImage.src = normalizedSrc;
      mainImage.removeAttribute('srcset');
      if (alt) mainImage.alt = alt;
      window.setTimeout(() => {
        mainImage.style.opacity = '';
      }, 80);
    };

    const clearTargetBcpoMainImage = () => {
      if (!preferBcpoColorImageAsMain) return;
      targetBcpoMainImageState.src = '';
      targetBcpoMainImageState.alt = '';
    };

    const enforceTargetBcpoMainImage = () => {
      if (!preferBcpoColorImageAsMain || !mainImage || !targetBcpoMainImageState.src || targetBcpoMainImageState.correcting) return;
      const currentFile = getImageFileName(mainImage.getAttribute('src') || mainImage.currentSrc || mainImage.src);
      const targetFile = getImageFileName(targetBcpoMainImageState.src);
      if (!targetFile || currentFile === targetFile) return;
      targetBcpoMainImageState.correcting = true;
      setMainImage(targetBcpoMainImageState.src, targetBcpoMainImageState.alt);
      window.setTimeout(() => {
        targetBcpoMainImageState.correcting = false;
      }, 0);
    };

    const activateThumb = (thumb) => {
      thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
      if (thumb) setMainImage(thumb.dataset.full, thumb.dataset.alt);
    };

    const getSwipeThumbs = () => thumbs.filter((thumb) => thumb && !thumb.hidden);

    const getActiveSwipeThumbIndex = (availableThumbs) => {
      const activeIndex = availableThumbs.findIndex((thumb) => thumb.classList.contains('is-active'));
      if (activeIndex >= 0) return activeIndex;

      const currentFile = getImageFileName(mainImage && (mainImage.getAttribute('src') || mainImage.currentSrc || mainImage.src));
      const matchingIndex = availableThumbs.findIndex((thumb) => currentFile && getImageFileName(thumb.dataset.full) === currentFile);
      return matchingIndex >= 0 ? matchingIndex : 0;
    };

    const activateSwipeThumb = (direction) => {
      const availableThumbs = getSwipeThumbs();
      if (availableThumbs.length < 2) return false;

      const currentIndex = getActiveSwipeThumbIndex(availableThumbs);
      const nextIndex = Math.max(0, Math.min(availableThumbs.length - 1, currentIndex + direction));
      if (nextIndex === currentIndex) return false;

      clearTargetBcpoMainImage();
      const nextThumb = availableThumbs[nextIndex];
      activateThumb(nextThumb);
      if (nextThumb && nextThumb.scrollIntoView) {
        try {
          nextThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        } catch (error) {
          nextThumb.scrollIntoView(false);
        }
      }
      return true;
    };

    const initMobileGallerySwipe = () => {
      if (!mainImageFrame || thumbs.length < 2) return;

      let isTracking = false;
      let isHorizontalGesture = false;
      let activePointerId = null;
      let startX = 0;
      let startY = 0;
      let lastX = 0;
      let lastY = 0;
      const minSwipeDistance = 44;

      const resetSwipe = () => {
        isTracking = false;
        isHorizontalGesture = false;
        activePointerId = null;
      };

      const beginSwipe = (clientX, clientY, pointerId) => {
        startX = clientX;
        startY = clientY;
        lastX = startX;
        lastY = startY;
        isTracking = true;
        isHorizontalGesture = false;
        activePointerId = pointerId == null ? null : pointerId;
      };

      const moveSwipe = (clientX, clientY, event) => {
        if (!isTracking) return;
        lastX = clientX;
        lastY = clientY;
        const deltaX = lastX - startX;
        const deltaY = lastY - startY;

        if (!isHorizontalGesture && Math.abs(deltaX) > 14 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25) {
          isHorizontalGesture = true;
        }

        if (isHorizontalGesture && event.cancelable) event.preventDefault();
      };

      const endSwipe = (clientX, clientY, event) => {
        if (!isTracking) return;
        const deltaX = clientX - startX;
        const deltaY = clientY - startY;
        const isSwipe = Math.abs(deltaX) >= minSwipeDistance && Math.abs(deltaX) > Math.abs(deltaY) * 1.35;

        resetSwipe();
        if (!isSwipe) return;
        if (event.cancelable) event.preventDefault();
        activateSwipeThumb(deltaX < 0 ? 1 : -1);
      };

      const getChangedTouch = (event) => {
        if (event.changedTouches && event.changedTouches.length) return event.changedTouches[0];
        if (event.touches && event.touches.length) return event.touches[0];
        return null;
      };

      if (window.PointerEvent) {
        mainImageFrame.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
          beginSwipe(event.clientX, event.clientY, event.pointerId);
          if (mainImageFrame.setPointerCapture) {
            try {
              mainImageFrame.setPointerCapture(event.pointerId);
            } catch (error) {}
          }
        });

        mainImageFrame.addEventListener('pointermove', (event) => {
          if (!isTracking || activePointerId !== event.pointerId) return;
          moveSwipe(event.clientX, event.clientY, event);
        });

        mainImageFrame.addEventListener('pointerup', (event) => {
          if (!isTracking || activePointerId !== event.pointerId) return;
          endSwipe(event.clientX, event.clientY, event);
          if (mainImageFrame.releasePointerCapture) {
            try {
              mainImageFrame.releasePointerCapture(event.pointerId);
            } catch (error) {}
          }
        });

        mainImageFrame.addEventListener('pointercancel', resetSwipe);
        return;
      }

      mainImageFrame.addEventListener('touchstart', (event) => {
        if (!event.touches || event.touches.length !== 1) {
          resetSwipe();
          return;
        }
        const touch = event.touches[0];
        beginSwipe(touch.clientX, touch.clientY);
      }, { passive: true });

      mainImageFrame.addEventListener('touchmove', (event) => {
        if (!isTracking || !event.touches || event.touches.length !== 1) return;
        const touch = event.touches[0];
        moveSwipe(touch.clientX, touch.clientY, event);
      }, { passive: false });

      mainImageFrame.addEventListener('touchend', (event) => {
        const touch = getChangedTouch(event);
        endSwipe(touch ? touch.clientX : lastX, touch ? touch.clientY : lastY, event);
      }, { passive: false });

      mainImageFrame.addEventListener('touchcancel', resetSwipe, { passive: true });
    };

    const updateCordedControls = (value) => {
      const isCorded = String(value || '').trim().toLowerCase() === 'corded';
      cordedBlocks.forEach((block) => {
        const shouldShow = isCorded && block.dataset.fdVoUnavailable !== 'true';
        block.hidden = !shouldShow;
        block.querySelectorAll('[data-fd-vo-sync]').forEach((control) => {
          control.disabled = !shouldShow;
        });
      });
      refreshTemplateStepNumbers();
    };

    const updateQuantity = (direction) => {
      if (!quantityInput) return;
      const current = Math.max(Number(quantityInput.value || 1), 1);
      const next = direction === 'plus' ? current + 1 : Math.max(current - 1, 1);
      quantityInput.value = String(next);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const groupMatchesValue = (group, handle) => {
      if (!group || group === 'all') return false;
      return group === handle || group === `color-${handle}` || group.endsWith(`-${handle}`) || group.includes(handle);
    };

    const updateGalleryGroup = (handle, fallbackImage) => {
      if (!handle) return;
      const hasGroup = thumbs.some((thumb) => groupMatchesValue(thumb.dataset.group, handle));

      if (!hasGroup) {
        thumbs.forEach((thumb) => {
          thumb.hidden = thumb.classList.contains('is-extra');
        });
        if (fallbackImage) setMainImage(fallbackImage);
        return;
      }

      let firstVisible = null;
      thumbs.forEach((thumb) => {
        const visible = groupMatchesValue(thumb.dataset.group, handle);
        thumb.hidden = !visible;
        if (visible && !firstVisible) firstVisible = thumb;
      });

      activateThumb(firstVisible);
    };

    const findSelectedVariant = () => {
      return variants.find((variant) => {
        const options = getVariantOptions(variant);
        return selectedOptions.every((value, index) => !value || options[index] === value);
      });
    };

    const updateVariant = (variant) => {
      if (!variant) {
        if (atc) atc.disabled = true;
        if (atcText) atcText.textContent = 'Unavailable';
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

      if (comparePrice) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePrice.hidden = false;
          comparePrice.textContent = formatMoney(variant.compare_at_price);
        } else {
          comparePrice.hidden = true;
        }
      }

      if (jennaBcpoPriceFallback) {
        window.setTimeout(jennaBcpoPriceFallback.updateDisplay, 40);
      }

      if (atc) atc.disabled = !variant.available;
      if (atcText) atcText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';

      const variantImage = variant.featured_image || variant.featured_media;
      if (variantImage && variantImage.src) {
        setMainImage(variantImage.src, variantImage.alt);
      }

      if (window.history && variant.id) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    };

    const getBcpoInput = (target, scope) => {
      if (!target || !target.closest) return null;
      const directInput = target.closest('#bcpo input');
      if (directInput) return directInput;
      const label = target.closest('#bcpo label');
      if (label) {
        const nestedInput = label.querySelector('input');
        if (nestedInput) return nestedInput;
        const controlId = label.getAttribute('for');
        const control = controlId ? document.getElementById(controlId) : null;
        if (control && control.closest && control.closest('#bcpo')) return control;
      }
      return scope ? scope.querySelector('.bcpo-front-image-option, .bcpo-front-color-option, input') : null;
    };

    const isColorInputName = (input) => {
      const inputName = String(input ? input.name : '').toLowerCase();
      return inputName.includes('[color]') || inputName.includes('[colour]') || inputName.includes('[fabric]');
    };

    const getBcpoLabel = (target, input, parent) => {
      if (!target || !target.closest) return null;
      const directLabel = target.closest('#bcpo .bcpo-front-image-label, #bcpo .bcpo-front-color-label, #bcpo label');
      if (directLabel) return directLabel;
      const parentLabel = parent ? parent.querySelector('.bcpo-front-image-label, .bcpo-front-color-label, label') : null;
      if (parentLabel) return parentLabel;
      if (!input || !input.id) return null;
      return Array.from(document.querySelectorAll('#bcpo label')).find((label) => label.getAttribute('for') === input.id) || null;
    };

    const decorateBcpoColorChoice = (choice) => {
      if (!choice || !choice.closest) return;
      const parent = choice.closest('#bcpo .bcpo-image-parent, #bcpo .bcpo-color-parent') || choice;
      const input = getBcpoInput(choice, parent);
      const labelElement = getBcpoLabel(choice, input, parent) || (choice.matches('label') ? choice : null);
      const selectedColor = input ? input.value : (labelElement ? labelElement.textContent : '');
      const swatchImage = getColorImage(selectedColor) || getCssBackgroundUrl(labelElement) || getCssBackgroundUrl(parent);

      parent.classList.add('fd-bcpo-color-choice');
      if (selectedColor) {
        const colorName = String(selectedColor).replace(/\s+/g, ' ').trim();
        parent.dataset.fdColorName = colorName;
        parent.setAttribute('title', colorName);
        parent.setAttribute('aria-label', colorName);
      }
      if (labelElement) {
        labelElement.classList.add('fd-bcpo-color-label');
        if (selectedColor) labelElement.setAttribute('title', selectedColor);
        if (swatchImage) applyBcpoChoiceImage(labelElement, swatchImage);
      } else if (swatchImage) {
        applyBcpoChoiceImage(parent, swatchImage);
      }

      const classText = `${parent.className || ''} ${labelElement ? labelElement.className : ''}`;
      const isSelected = Boolean(input && input.checked) || /\b(active|selected|checked)\b/i.test(classText);
      parent.classList.toggle('fd-bcpo-is-selected', isSelected);
    };

    const getBcpoColorChoice = (target) => {
      return target && target.closest ? target.closest('#bcpo .bcpo-image-parent, #bcpo .bcpo-color-parent') : null;
    };

    const getBcpoColorChoiceValue = (choice) => {
      if (!choice) return '';
      const input = getBcpoInput(choice, choice);
      if (input && input.value) return input.value;
      return choice.dataset.fdColorName || choice.textContent || '';
    };

    const isSameBcpoColorValue = (first, second) => {
      const firstValue = String(first || '').trim();
      const secondValue = String(second || '').trim();
      return Boolean(firstValue && secondValue) && (
        firstValue === secondValue
        || firstValue.toLowerCase() === secondValue.toLowerCase()
        || handleize(firstValue) === handleize(secondValue)
      );
    };

    const setBcpoColorChoiceSelected = (choice, selected) => {
      if (!choice || !choice.classList) return;
      choice.classList.toggle('fd-bcpo-is-selected', selected);
      if (selected) return;
      ['active', 'selected', 'checked'].forEach((className) => choice.classList.remove(className));
      choice.querySelectorAll('.bcpo-front-image-label, .bcpo-front-color-label, label').forEach((label) => {
        ['active', 'selected', 'checked'].forEach((className) => label.classList.remove(className));
      });
    };

    const syncBcpoColorSelection = (wrapper, activeTarget) => {
      if (!wrapper || !wrapper.querySelectorAll) return;
      const choices = Array.from(wrapper.querySelectorAll('.bcpo-image-parent, .bcpo-color-parent'));
      if (!choices.length) return;

      const activeChoice = getBcpoColorChoice(activeTarget);
      const checkedChoices = choices.filter((choice) => {
        const input = getBcpoInput(choice, choice);
        return Boolean(input && input.checked);
      });
      const currentColorLabel = root.querySelector('[data-fd-color-label]');
      const currentColor = (colorProperty && colorProperty.value) || (currentColorLabel ? currentColorLabel.textContent : '');
      const currentColorChoice = currentColor
        ? choices.find((choice) => isSameBcpoColorValue(getBcpoColorChoiceValue(choice), currentColor))
        : null;
      const selectedByClass = choices.filter((choice) => {
        const labelElement = getBcpoLabel(choice, getBcpoInput(choice, choice), choice);
        const classText = `${choice.className || ''} ${labelElement ? labelElement.className : ''}`;
        return /\b(active|selected|checked|fd-bcpo-is-selected)\b/i.test(classText);
      });
      const fallbackChoice = checkedChoices[checkedChoices.length - 1]
        || (activeChoice && wrapper.contains(activeChoice) ? activeChoice : null)
        || currentColorChoice
        || (selectedByClass.length === 1 ? selectedByClass[0] : null);

      choices.forEach((choice) => {
        const input = getBcpoInput(choice, choice);
        const selected = checkedChoices.length
          ? Boolean(input && input.checked)
          : choice === fallbackChoice;
        setBcpoColorChoiceSelected(choice, selected);
      });
    };

    const decorateBcpoColorOptions = () => {
      const bcpoRoot = root.querySelector('#bcpo') || document.querySelector('#bcpo');
      if (!bcpoRoot) return;
      const colorIndexes = getBcpoColorOptionIndexes();

      bcpoRoot.querySelectorAll('.selector-wrapper').forEach((wrapper) => {
        if (!isBcpoColorWrapper(wrapper, colorIndexes)) return;
        wrapper.classList.add('fd-bcpo-color-option');
        const titleLabel = wrapper.querySelector('.bcpo-label') || wrapper.querySelector('.bcpo-title') || Array.from(wrapper.children || []).find((child) => child.tagName === 'LABEL');
        if (titleLabel) titleLabel.classList.add('fd-bcpo-color-title');
        if (!wrapper.querySelector('.fd-bcpo-color-note')) {
          const note = document.createElement('div');
          note.className = 'fd-bcpo-color-note';
          note.textContent = 'Lighting, screen, and batch variations may affect color -- swatches recommended first.';
          if (titleLabel && titleLabel.parentNode === wrapper) {
            titleLabel.insertAdjacentElement('afterend', note);
          } else {
            wrapper.insertBefore(note, wrapper.firstChild);
          }
        }

        wrapper.querySelectorAll('.bcpo-image-parent, .bcpo-color-parent').forEach((choice) => {
          decorateBcpoColorChoice(choice);
        });
        syncBcpoColorSelection(wrapper);
      });
    };

    const isBcpoColorTarget = (target) => {
      if (!target || !target.closest) return false;
      const wrapper = target.closest('#bcpo .selector-wrapper');
      const scope = wrapper || target.closest('#bcpo .bcpo-image-parent, #bcpo .bcpo-color-parent, #bcpo label, #bcpo');
      const input = getBcpoInput(target, scope);

      if (isColorInputName(input)) return true;

      const colorIndexes = getBcpoColorOptionIndexes();
      const nameMatch = input && String(input.name || '').match(/^name(\d+)$/);
      if (nameMatch && colorIndexes.has(Number(nameMatch[1]))) return true;

      if (wrapper && isBcpoColorWrapper(wrapper, colorIndexes)) return true;

      return Boolean(input && input.matches && input.matches('.bcpo-front-image-option, .bcpo-front-color-option') && getColorImage(input.value));
    };

    const updateBcpoColorImage = (target) => {
      if (!isBcpoColorTarget(target)) return false;
      const wrapper = target.closest('#bcpo .selector-wrapper');
      syncBcpoColorSelection(wrapper, target);
      const parent = getBcpoColorChoice(target);
      const input = getBcpoInput(target, parent || wrapper || target.closest('#bcpo'));
      const labelElement = getBcpoLabel(target, input, parent);
      const selectedColor = input ? input.value : '';
      const productImage = getProductColorImage(selectedColor);
      const swatchImage = getColorImage(selectedColor) || getCssBackgroundUrl(labelElement) || getCssBackgroundUrl(parent);
      if (preferBcpoColorImageAsMain && swatchImage) {
        targetBcpoMainImageState.src = expandBcpoImageUrl(swatchImage);
        targetBcpoMainImageState.alt = selectedColor || '';
      }
      const mainImageSrc = (preferBcpoColorImageAsMain && swatchImage)
        ? swatchImage
        : (productImage || (canUseSwatchImageAsMain(swatchImage) ? swatchImage : ''));

      if (!selectedColor && !swatchImage && !productImage) return false;
      root.querySelectorAll('[data-fd-color-label]').forEach((label) => {
        label.textContent = selectedColor;
      });
      if (colorProperty && selectedColor) colorProperty.value = selectedColor;
      if (mainImageSrc) {
        setMainImage(mainImageSrc, selectedColor);
        enforceTargetBcpoMainImage();
      }
      decorateBcpoColorOptions();
      syncBcpoColorSelection(wrapper, target);
      return true;
    };

    const scheduleBcpoColorImageUpdate = (target) => {
      const delays = preferBcpoColorImageAsMain ? [0, 80, 250, 600, 1200, 2200] : [0, 80, 250, 600];
      delays.forEach((delay) => {
        window.setTimeout(() => {
          decorateBcpoColorOptions();
          updateBcpoColorImage(target);
          enforceTargetBcpoMainImage();
        }, delay);
      });
    };

    const normalizeVoText = (value) => String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

    const getBcpoOptions = () => {
      const bcpoData = window.bcpo_data;
      return bcpoData && Array.isArray(bcpoData.virtual_options) ? bcpoData.virtual_options : [];
    };

    const getBcpoOptionByIndex = (index) => {
      const options = getBcpoOptions();
      if (index >= 0 && options[index]) return options[index];
      if (index > 0 && options[index - 1]) return options[index - 1];
      return null;
    };

    const getBcpoWrapperOption = (wrapper) => {
      if (!wrapper) return null;
      const control = wrapper.querySelector('input, select, textarea');
      const nameMatch = control && String(control.name || '').match(/^name(\d+)$/);
      if (nameMatch) return getBcpoOptionByIndex(Number(nameMatch[1]));

      const propertyMatch = control && String(control.name || '').match(/^properties\[(.+)\]$/);
      if (propertyMatch) {
        const propertyTitle = propertyMatch[1];
        const matchingOption = getBcpoOptions().find((option) => voTitleMatches(option && option.title, propertyTitle));
        if (matchingOption) return matchingOption;
      }

      const dataOption = String(wrapper.getAttribute('data-option') || '');
      const dataMatch = dataOption.match(/^option(\d+)$/i);
      if (dataMatch) return getBcpoOptionByIndex(Number(dataMatch[1]));

      const title = normalizeVoText(getBcpoWrapperTitle(wrapper));
      return getBcpoOptions().find((option) => normalizeVoText(option && option.title) === title) || null;
    };

    const getBcpoWrapperOptionTitle = (wrapper) => {
      const option = getBcpoWrapperOption(wrapper);
      return option && option.title ? option.title : getBcpoWrapperTitle(wrapper);
    };

    const getBcpoWrappers = () => {
      const bcpoRoot = root.querySelector('#bcpo') || document.querySelector('#bcpo');
      const scope = bcpoRoot || root;
      return Array.from(new Set(Array.from(scope.querySelectorAll('.selector-wrapper, [data-option], .bcpo-selector-wrapper, .bold_option'))))
        .filter((wrapper) => wrapper !== root && wrapper !== form);
    };

    const isForceHiddenFractionText = (title) => {
      const titleText = normalizeVoText(title);
      return titleText === 'width fraction'
        || titleText.startsWith('width fraction ')
        || titleText === 'height fraction'
        || titleText.startsWith('height fraction ');
    };

    const isForceHiddenBcpoTitle = (title) => isForceHiddenFractionText(title);

    const isForceHiddenBcpoControl = (control) => {
      if (!control) return false;
      const controlText = normalizeVoText(`${control.name || ''} ${control.id || ''}`);
      return controlText.includes('width fraction') || controlText.includes('height fraction');
    };

    const isForceHiddenBcpoWrapper = (wrapper) => {
      if (!wrapper) return false;
      if (isForceHiddenBcpoTitle(getBcpoWrapperOptionTitle(wrapper))) return true;
      if (isForceHiddenFractionText(wrapper.innerText || wrapper.textContent)) return true;
      return Array.from(wrapper.querySelectorAll('input, select, textarea')).some(isForceHiddenBcpoControl);
    };

    const setForceHiddenBcpoDefault = (control) => {
      if (!control) return;
      if (control.tagName === 'BUTTON') return;
      const type = String(control.type || '').toLowerCase();
      if (control.tagName === 'SELECT') {
        const options = Array.from(control.options || []);
        const isPlaceholderOption = (option) => {
          const text = normalizeVoText(option ? option.textContent : '');
          const value = normalizeVoText(option ? option.value : '');
          return !value || value === 'choose one' || text === 'choose one' || text === 'select one' || text === 'select';
        };
        if (isPlaceholderOption(options[control.selectedIndex])) {
          const preferred = options.find((option) => {
            const text = normalizeVoText(`${option.value || ''} ${option.textContent || ''}`);
            return !isPlaceholderOption(option) && (text === '0' || text.includes('no fraction') || text.includes('none'));
          }) || options.find((option) => !isPlaceholderOption(option));
          if (preferred) control.value = preferred.value;
        }
        dispatchVoChange(control);
        return;
      }
      if (type === 'radio' || type === 'checkbox') {
        const group = control.name
          ? Array.from((control.form || document).querySelectorAll(`input[type="${type}"][name="${CSS.escape(control.name)}"]`))
          : [control];
        if (!group.some((item) => item.checked)) {
          const choice = group.find((item) => !item.disabled) || control;
          choice.checked = true;
          dispatchVoChange(choice);
        }
        return;
      }
      if (!String(control.value || '').trim()) {
        control.value = '0';
        dispatchVoChange(control);
      }
    };

    const setForceHiddenBcpoWrapper = (wrapper, shouldHide) => {
      if (!wrapper) return;
      wrapper.classList.toggle('fd-bcpo-force-hidden', shouldHide);
      if (shouldHide) {
        wrapper.setAttribute('aria-hidden', 'true');
        if (!Object.prototype.hasOwnProperty.call(wrapper.dataset, 'fdForceHiddenDisplay')) {
          wrapper.dataset.fdForceHiddenDisplay = wrapper.style.display || '';
        }
        wrapper.style.display = 'none';
        wrapper.querySelectorAll('input, select, textarea, button').forEach((control) => {
          if (!Object.prototype.hasOwnProperty.call(control.dataset, 'fdForceHiddenDisabled')) {
            control.dataset.fdForceHiddenDisabled = control.disabled ? 'true' : 'false';
          }
          setForceHiddenBcpoDefault(control);
          control.dataset.fdForceHiddenBcpo = 'true';
          control.removeAttribute('required');
          control.disabled = control.dataset.fdForceHiddenDisabled === 'true';
          control.setAttribute('aria-hidden', 'true');
        });
      } else if (!wrapper.classList.contains('fd-bcpo-template-hidden')) {
        wrapper.removeAttribute('aria-hidden');
        if (Object.prototype.hasOwnProperty.call(wrapper.dataset, 'fdForceHiddenDisplay')) {
          wrapper.style.display = wrapper.dataset.fdForceHiddenDisplay;
          delete wrapper.dataset.fdForceHiddenDisplay;
        }
        wrapper.querySelectorAll('[data-fd-force-hidden-bcpo]').forEach((control) => {
          delete control.dataset.fdForceHiddenBcpo;
          if (Object.prototype.hasOwnProperty.call(control.dataset, 'fdForceHiddenDisabled')) {
            control.disabled = control.dataset.fdForceHiddenDisabled === 'true';
            delete control.dataset.fdForceHiddenDisabled;
          }
          control.removeAttribute('aria-hidden');
        });
      }
    };

    const applyForceHiddenBcpoOptions = () => {
      getBcpoWrappers().forEach((wrapper) => {
        setForceHiddenBcpoWrapper(wrapper, isForceHiddenBcpoWrapper(wrapper));
      });
    };

    const refreshDuplicateThemeColorOptions = () => {
      if (root.dataset.windowTreatment === 'true') return false;
      const colorIndexes = getBcpoColorOptionIndexes();
      const hasBcpoColor = getBcpoWrappers().some((wrapper) => (
        isBcpoColorWrapper(wrapper, colorIndexes) || isBcpoColorTitle(getBcpoWrapperOptionTitle(wrapper))
      ));
      root.querySelectorAll('[data-fd-theme-color-option]').forEach((field) => {
        field.hidden = hasBcpoColor;
        if (hasBcpoColor) field.setAttribute('aria-hidden', 'true');
        else field.removeAttribute('aria-hidden');
      });
      return hasBcpoColor;
    };

    const voTitleMatches = (title, query) => {
      const titleText = normalizeVoText(title);
      const queryText = normalizeVoText(query);
      if (!titleText || !queryText) return false;
      return titleText === queryText || titleText.includes(queryText) || queryText.includes(titleText);
    };

    const findBcpoOption = (query) => {
      const optionQuery = String(query || '').trim();
      if (!optionQuery) return null;
      return getBcpoOptions().find((option) => voTitleMatches(option && option.title, optionQuery)) || null;
    };

    const findBcpoWrapperForOption = (option) => {
      if (!option) return null;
      const title = normalizeVoText(option.title);
      return getBcpoWrappers().find((wrapper) => {
        const wrapperOption = getBcpoWrapperOption(wrapper);
        if (wrapperOption && wrapperOption === option) return true;
        return voTitleMatches(getBcpoWrapperOptionTitle(wrapper), title);
      }) || null;
    };

    const valueMatches = (candidate, desired) => {
      const candidateText = normalizeVoText(candidate);
      const desiredText = normalizeVoText(desired);
      if (!candidateText || !desiredText) return false;
      return candidateText === desiredText || candidateText.includes(desiredText) || desiredText.includes(candidateText);
    };

    const dispatchVoChange = (control) => {
      if (!control) return;
      control.dispatchEvent(new Event('input', { bubbles: true }));
      control.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const syncTemplateRadioGroup = (control) => {
      if (!control || control.type !== 'radio') return;
      const field = control.closest('[data-fd-vo-template-field]') || control.closest('[data-fd-vo-template]');
      if (!field) return;
      const optionName = control.dataset.fdVoOption || '';
      field.querySelectorAll('input[type="radio"][data-fd-vo-sync]').forEach((input) => {
        if ((input.dataset.fdVoOption || '') === optionName) input.checked = input === control;
      });
    };

    const setTemplateControlToVoMode = (control, enabled) => {
      if (!control) return;
      const shell = control.closest('label');
      if (shell && shell.closest('[data-fd-vo-template-field]')) shell.hidden = !enabled;
      if (enabled) {
        if (!control.dataset.fdOriginalName && control.name) control.dataset.fdOriginalName = control.name;
        control.removeAttribute('name');
        control.disabled = false;
        control.dataset.fdVoReady = 'true';
      } else {
        if (control.dataset.fdOriginalName) control.name = control.dataset.fdOriginalName;
        control.disabled = true;
        delete control.dataset.fdVoReady;
      }
    };

    const refreshCompositeTemplateLabels = (template) => {
      if (!template) return;
      template.querySelectorAll('[data-fd-vo-template-field]').forEach((field) => {
        const fieldsGrid = field.querySelector('.fd-pdp-fields');
        if (fieldsGrid) {
          const visibleFields = Array.from(fieldsGrid.children || []).filter((child) => !child.hidden);
          fieldsGrid.classList.toggle('fd-pdp-fields--single', visibleFields.length === 1);
        }

        const title = field.querySelector('.fd-pdp-step-label span');
        if (!title || normalizeVoText(title.dataset.fdOriginalLabel || title.textContent) !== 'lining and edge binding') return;
        if (!title.dataset.fdOriginalLabel) title.dataset.fdOriginalLabel = title.textContent;

        const controls = Array.from(field.querySelectorAll('[data-fd-vo-sync]'));
        const hasLining = controls.some((control) => control.dataset.fdVoReady === 'true' && normalizeVoText(control.dataset.fdVoOption).includes('lining'));
        const hasEdgeBinding = controls.some((control) => control.dataset.fdVoReady === 'true' && normalizeVoText(control.dataset.fdVoOption).includes('edge binding'));

        if (hasLining && hasEdgeBinding) title.textContent = title.dataset.fdOriginalLabel;
        else if (hasLining) title.textContent = 'Lining';
        else if (hasEdgeBinding) title.textContent = 'Edge Binding';
        else title.textContent = title.dataset.fdOriginalLabel;
      });
    };

    const syncSelectOptionsFromVo = (control, option) => {
      if (!control || control.tagName !== 'SELECT' || !option || !Array.isArray(option.values) || !option.values.length) return;
      if (control.dataset.fdVoOptionsLoaded === normalizeVoText(option.title)) return;
      const currentValue = control.value;
      control.innerHTML = '';
      option.values.forEach((item) => {
        const key = String(item && item.key ? item.key : '').trim();
        if (!key) return;
        const optionElement = document.createElement('option');
        optionElement.value = key;
        optionElement.textContent = key;
        control.appendChild(optionElement);
      });
      const matchingOption = Array.from(control.options).find((item) => valueMatches(item.value, currentValue));
      if (matchingOption) control.value = matchingOption.value;
      control.dataset.fdVoOptionsLoaded = normalizeVoText(option.title);
    };

    const syncNumberConstraintsFromVo = (control, option) => {
      if (!control || control.type !== 'number' || !option || !Array.isArray(option.values) || !option.values.length) return;
      const numbers = option.values
        .map((item) => Number.parseFloat(String(item && item.key ? item.key : '').trim()))
        .filter((value) => Number.isFinite(value))
        .sort((a, b) => a - b);
      if (!numbers.length) return;

      const min = numbers[0];
      const max = numbers[numbers.length - 1];
      control.min = String(min);
      control.max = String(max);
      control.step = '1';

      const placeholder = Number.parseFloat(control.getAttribute('placeholder') || '');
      if (Number.isFinite(placeholder) && (placeholder < min || placeholder > max)) {
        control.setAttribute('placeholder', String(max));
      }
    };

    const syncTemplateControlToVo = (control) => {
      if (!control || control.disabled || control.closest('[hidden]') || control.dataset.fdVoReady !== 'true') return false;
      const option = findBcpoOption(control.dataset.fdVoOption);
      const wrapper = findBcpoWrapperForOption(option);
      const value = String(control.dataset.fdVoValue || control.value || '').trim();
      if (!option || !wrapper || !value) return false;

      const select = wrapper.querySelector('select');
      if (select) {
        const match = Array.from(select.options).find((item) => valueMatches(item.value || item.textContent, value));
        if (match) {
          select.value = match.value;
          dispatchVoChange(select);
          return true;
        }
      }

      const inputs = Array.from(wrapper.querySelectorAll('input, textarea'));
      const choice = inputs.find((input) => {
        const inputValue = input.value || input.getAttribute('value') || '';
        return valueMatches(inputValue, value);
      });
      if (choice) {
        if (choice.type === 'radio' || choice.type === 'checkbox') {
          if (!choice.checked) choice.click();
          choice.checked = true;
        } else {
          choice.value = value;
        }
        dispatchVoChange(choice);
        return true;
      }

      const openInput = inputs.find((input) => !/^(radio|checkbox|hidden)$/i.test(input.type || ''));
      if (openInput) {
        openInput.value = value;
        dispatchVoChange(openInput);
        return true;
      }

      return false;
    };

    const refreshTemplateStepNumbers = () => {
      const template = root.querySelector('[data-fd-vo-template]');
      if (!template) return;
      let number = 0;
      template.querySelectorAll('[data-fd-vo-template-field]').forEach((field) => {
        if (field.hidden || field.dataset.fdVoUnavailable === 'true') return;
        const badge = field.querySelector('.fd-pdp-step-label b');
        if (badge) {
          number += 1;
          badge.textContent = String(number);
        }
      });
    };

    const refreshVoTemplate = () => {
      const template = root.querySelector('[data-fd-vo-template]');
      const bcpoRoot = root.querySelector('#bcpo') || document.querySelector('#bcpo');
      const bcpoWrappers = getBcpoWrappers();
      if (!template || (!bcpoRoot && !bcpoWrappers.length) || !getBcpoOptions().length) return false;

      const matchedTitles = new Set();
      const fields = Array.from(template.querySelectorAll('[data-fd-vo-template-field]'));
      fields.forEach((field) => {
        const controls = Array.from(field.querySelectorAll('[data-fd-vo-sync]'));
        let hasMappedControl = false;

        controls.forEach((control) => {
          const option = findBcpoOption(control.dataset.fdVoOption);
          const hasOption = Boolean(option);
          setTemplateControlToVoMode(control, hasOption);
          if (!hasOption) return;

          hasMappedControl = true;
          matchedTitles.add(normalizeVoText(option.title));
          syncSelectOptionsFromVo(control, option);
          syncNumberConstraintsFromVo(control, option);
        });

        if (controls.length) {
          field.dataset.fdVoUnavailable = hasMappedControl ? 'false' : 'true';
          field.hidden = !hasMappedControl;
          field.querySelectorAll('input, select, textarea').forEach((control) => {
            if (!controls.includes(control)) control.disabled = !hasMappedControl;
          });
        } else if (field.dataset.fdVoOptionalField === 'true' || field.hasAttribute('data-fd-vo-optional-field')) {
          field.dataset.fdVoUnavailable = 'true';
          field.hidden = true;
          field.querySelectorAll('input, select, textarea').forEach((control) => {
            control.disabled = true;
          });
        }
      });

      const colorIndexes = getBcpoColorOptionIndexes();
      bcpoWrappers.forEach((wrapper) => {
        const title = getBcpoWrapperOptionTitle(wrapper);
        const forceHidden = isForceHiddenBcpoWrapper(wrapper);
        const isColorWrapper = isBcpoColorWrapper(wrapper, colorIndexes) || isBcpoColorTitle(title);
        const normalizedTitle = normalizeVoText(title);
        const shouldHide = !forceHidden && !isColorWrapper && Array.from(matchedTitles).some((matchedTitle) => (
          normalizedTitle === matchedTitle || normalizedTitle.includes(matchedTitle) || matchedTitle.includes(normalizedTitle)
        ));
        setForceHiddenBcpoWrapper(wrapper, forceHidden);
        wrapper.classList.toggle('fd-bcpo-template-hidden', shouldHide);
        if (shouldHide || forceHidden) wrapper.setAttribute('aria-hidden', 'true');
        else wrapper.removeAttribute('aria-hidden');
      });

      refreshDuplicateThemeColorOptions();

      const checkedLift = template.querySelector('[data-fd-lift-input]:checked');
      if (checkedLift) updateCordedControls(checkedLift.value);

      template.querySelectorAll('[data-fd-vo-sync]').forEach((control) => {
        if ((control.type === 'radio' || control.type === 'checkbox') && !control.checked) return;
        syncTemplateControlToVo(control);
      });
      refreshCompositeTemplateLabels(template);
      refreshTemplateStepNumbers();
      return true;
    };

    const isHiddenForValidation = (element) => {
      if (!element) return true;
      if (element.hidden || element.getAttribute('aria-hidden') === 'true') return true;
      if (element.closest('[hidden], .fd-bcpo-template-hidden, .fd-bcpo-force-hidden, [aria-hidden="true"]')) return true;
      if (!window.getComputedStyle) return false;
      const style = window.getComputedStyle(element);
      return style.display === 'none' || style.visibility === 'hidden';
    };

    const isPlaceholderChoice = (control) => {
      if (!control || control.tagName !== 'SELECT') return false;
      const selected = control.options[control.selectedIndex];
      const valueText = normalizeVoText(control.value || (selected ? selected.textContent : ''));
      const optionText = normalizeVoText(selected ? selected.textContent : '');
      return !valueText || valueText === 'choose one' || optionText === 'choose one' || optionText === 'select one' || optionText === 'select';
    };

    const isHiddenControlForValidation = (control) => {
      if (!control) return true;
      const type = String(control.type || '').toLowerCase();
      if ((type === 'radio' || type === 'checkbox') && !control.closest('[hidden], .fd-bcpo-template-hidden, .fd-bcpo-force-hidden, [aria-hidden="true"]')) {
        return false;
      }
      return isHiddenForValidation(control);
    };

    const getFieldControls = (field) => Array.from(field ? field.querySelectorAll('input, select, textarea') : [])
      .filter((control) => control.type !== 'hidden' && !control.disabled && !isHiddenControlForValidation(control));

    const getChoiceGroupKey = (control, controls) => {
      const key = control.name || control.dataset.fdOriginalName || control.dataset.fdVoOption || control.id || '';
      if (key) return `${control.type}:${key}`;
      return `${control.type}:field:${controls.indexOf(control)}`;
    };

    const controlHasValue = (control, controls) => {
      if (!control || control.disabled || isHiddenForValidation(control)) return true;
      const type = String(control.type || '').toLowerCase();
      if (type === 'radio' || type === 'checkbox') {
        const groupKey = getChoiceGroupKey(control, controls);
        const group = controls.filter((item) => item.type === control.type && getChoiceGroupKey(item, controls) === groupKey);
        return group.some((item) => item.checked);
      }
      if (control.tagName === 'SELECT') return !isPlaceholderChoice(control);
      if (type === 'file') return Boolean(control.files && control.files.length);
      const value = String(control.value || '').trim();
      if (!value) return false;
      return typeof control.checkValidity === 'function' ? control.checkValidity() : true;
    };

    const getFieldLabelText = (field, fallback) => {
      const label = field && (field.querySelector('.fd-pdp-step-label span, .bcpo-title, .bcpo-label, label') || field);
      return String(label ? label.textContent : fallback || 'this option').replace(/\s+/g, ' ').trim() || fallback || 'this option';
    };

    const getValidationError = () => {
      let error = form.querySelector('[data-fd-pdp-form-error]');
      if (error) return error;
      error = document.createElement('div');
      error.className = 'fd-pdp-form-error';
      error.setAttribute('role', 'alert');
      error.setAttribute('data-fd-pdp-form-error', '');
      error.hidden = true;
      if (atc && atc.parentNode === form) form.insertBefore(error, atc);
      else form.appendChild(error);
      return error;
    };

    const setInvalidField = (field, invalid) => {
      if (!field) return;
      field.classList.toggle('is-fd-invalid', invalid);
      if (invalid) field.setAttribute('aria-invalid', 'true');
      else field.removeAttribute('aria-invalid');
    };

    const clearValidationState = () => {
      root.querySelectorAll('.is-fd-invalid').forEach((field) => setInvalidField(field, false));
      document.querySelectorAll('#bcpo .is-fd-invalid').forEach((field) => setInvalidField(field, false));
      const error = form ? form.querySelector('[data-fd-pdp-form-error]') : null;
      if (error) error.hidden = true;
    };

    const validateRequiredField = (field) => {
      if (!field || isHiddenForValidation(field)) return null;
      const controls = getFieldControls(field);
      if (!controls.length) return null;
      const checkedGroups = new Set();
      const invalidControl = controls.find((control) => {
        const type = String(control.type || '').toLowerCase();
        if (type === 'radio' || type === 'checkbox') {
          const groupKey = getChoiceGroupKey(control, controls);
          if (checkedGroups.has(groupKey)) return false;
          checkedGroups.add(groupKey);
        }
        return !controlHasValue(control, controls);
      });
      return invalidControl ? { field, control: invalidControl, label: getFieldLabelText(field) } : null;
    };

    const validateCustomizationBeforeSubmit = () => {
      if (!form || root.dataset.windowTreatment !== 'true') return true;
      clearValidationState();
      applyForceHiddenBcpoOptions();
      refreshVoTemplate();

      const invalidFields = [];
      root.querySelectorAll('[data-fd-vo-template-field]').forEach((field) => {
        if (field.dataset.fdVoOptionalField === 'true' || field.hasAttribute('data-fd-vo-optional-field')) return;
        if (field.dataset.fdVoUnavailable === 'true') return;
        const invalid = validateRequiredField(field);
        if (invalid) invalidFields.push(invalid);
      });

      const colorIndexes = getBcpoColorOptionIndexes();
      getBcpoWrappers().forEach((wrapper) => {
        if (isHiddenForValidation(wrapper)) return;
        const title = getBcpoWrapperOptionTitle(wrapper);
        if (isForceHiddenBcpoWrapper(wrapper)) return;
        const option = getBcpoWrapperOption(wrapper);
        const shouldRequire = (option && option.required === 'on') || isBcpoColorWrapper(wrapper, colorIndexes) || isBcpoColorTitle(title);
        if (!shouldRequire) return;
        const invalid = validateRequiredField(wrapper);
        if (invalid) invalidFields.push(invalid);
      });

      if (!invalidFields.length) return true;

      invalidFields.forEach((item) => setInvalidField(item.field, true));
      const first = invalidFields[0];
      const error = getValidationError();
      error.textContent = `Please complete ${first.label} before adding to cart.`;
      error.hidden = false;

      const focusTarget = first.control && typeof first.control.focus === 'function' ? first.control : first.field;
      if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus({ preventScroll: true });
      window.requestAnimationFrame(() => {
        first.field.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      return false;
    };

    const pdpTabs = Array.from(root.querySelectorAll('.fd-pdp-tabs a[href^="#"]'));
    const getScrollOffset = () => {
      const header = document.querySelector('[data-fd-global-header], .site-header, header');
      return (header ? header.getBoundingClientRect().height : 0) + 18;
    };
    const activateDetailTab = (link, shouldPushState) => {
      if (!link) return false;
      const hash = link.getAttribute('href');
      if (!hash || hash.charAt(0) !== '#') return false;
      const target = document.getElementById(hash.slice(1));
      if (!target) return false;

      if (target.tagName === 'DETAILS') target.open = true;
      pdpTabs.forEach((tab) => tab.classList.toggle('is-active', tab === link));

      if (shouldPushState && window.history && window.history.pushState) {
        window.history.pushState(null, '', hash);
      }

      window.requestAnimationFrame(() => {
        const top = target.getBoundingClientRect().top + window.pageYOffset - getScrollOffset();
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      });

      return true;
    };

    const blockInvalidCustomization = (event) => {
      if (validateCustomizationBeforeSubmit()) return false;
      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      return true;
    };

    if (form) {
      form.addEventListener('submit', blockInvalidCustomization, true);
    }

    root.addEventListener('click', (event) => {
      const target = event.target && event.target.closest ? event.target : null;
      if (!target) return;
      if (target.closest('[data-fd-atc], [data-fd-sticky-submit]')) blockInvalidCustomization(event);
    }, true);

    root.addEventListener('click', (event) => {
      const target = event.target && event.target.closest ? event.target : null;
      if (!target) return;

      const detailTab = target.closest('.fd-pdp-tabs a[href^="#"]');
      if (detailTab) {
        event.preventDefault();
        activateDetailTab(detailTab, true);
        return;
      }

      const qtyButton = target.closest('[data-fd-qty-action]');
      if (qtyButton) {
        updateQuantity(qtyButton.dataset.fdQtyAction);
        return;
      }

      const bcpoColorTarget = target.closest('#bcpo .bcpo-image-parent, #bcpo .bcpo-color-parent, #bcpo .bcpo-front-image-label, #bcpo .bcpo-front-color-label, #bcpo .bcpo-front-image-option, #bcpo .bcpo-front-color-option, #bcpo input, #bcpo label');
      if (bcpoColorTarget && isBcpoColorTarget(bcpoColorTarget)) {
        scheduleBcpoColorImageUpdate(bcpoColorTarget);
        return;
      }

      const mediaSwatch = target.closest('[data-fd-media-swatch]');
      if (mediaSwatch) {
        const selectedColor = mediaSwatch.dataset.label || mediaSwatch.dataset.alt || '';
        const group = mediaSwatch.closest('.fd-pdp-option--media');
        if (group) {
          group.querySelectorAll('[data-fd-media-swatch]').forEach((button) => {
            button.classList.toggle('is-selected', button === mediaSwatch);
          });
        }
        root.querySelectorAll('[data-fd-color-label]').forEach((label) => {
          label.textContent = selectedColor;
        });
        if (colorProperty && selectedColor) colorProperty.value = selectedColor;
        const swatchImage = mediaSwatch.dataset.image || getColorImage(selectedColor);
        if (swatchImage) mediaSwatch.dataset.image = swatchImage;
        setMainImage(swatchImage, mediaSwatch.dataset.alt || selectedColor);
        return;
      }

      const thumb = target.closest('[data-fd-thumb]');
      if (thumb) {
        clearTargetBcpoMainImage();
        activateThumb(thumb);
        return;
      }

      const valueButton = target.closest('[data-fd-option-value]');
      if (valueButton) {
        const position = Number(valueButton.dataset.optionPosition || '1') - 1;
        const group = valueButton.closest('[data-fd-option-position]');
        selectedOptions[position] = valueButton.dataset.optionValue;

        if (group) {
          group.querySelectorAll('[data-fd-option-value]').forEach((button) => {
            button.classList.toggle('is-selected', button === valueButton);
          });
        }

        if (group && group.classList.contains('fd-pdp-option--color')) {
          updateVariant(findSelectedVariant());

          root.querySelectorAll('[data-fd-color-label]').forEach((label) => {
            label.textContent = valueButton.dataset.optionValue;
          });
          const optionImage = valueButton.dataset.image || getColorImage(valueButton.dataset.optionValue);
          if (optionImage) {
            valueButton.dataset.image = optionImage;
            setMainImage(optionImage, valueButton.dataset.optionValue);
          }
          updateGalleryGroup(valueButton.dataset.valueHandle, optionImage);
        } else {
          updateVariant(findSelectedVariant());
        }
        return;
      }

      const seeMore = target.closest('[data-fd-see-more]');
      if (seeMore) {
        thumbs.forEach((item) => {
          if (item.classList.contains('is-extra')) item.hidden = false;
        });
        seeMore.hidden = true;
        return;
      }

      const copyButton = target.closest('[data-fd-copy]');
      if (copyButton) {
        const value = copyButton.dataset.fdCopy;
        if (navigator.clipboard && value) {
          navigator.clipboard.writeText(value).catch(() => {});
        }
        copyButton.classList.add('is-copied');
        window.setTimeout(() => copyButton.classList.remove('is-copied'), 1200);
        return;
      }

      const stickySubmit = target.closest('[data-fd-sticky-submit]');
      if (stickySubmit && form) {
        const submit = form.querySelector('[type="submit"]');
        if (submit) submit.click();
        return;
      }

      const cookieClose = target.closest('[data-fd-cookie-close]');
      if (cookieClose) {
        const cookie = root.querySelector('[data-fd-cookie]');
        if (cookie) cookie.hidden = true;
      }
    });

    document.addEventListener('click', (event) => {
      const target = event.target && event.target.closest ? event.target : null;
      if (!target) return;
      const bcpoColorTarget = target.closest('#bcpo .bcpo-image-parent, #bcpo .bcpo-color-parent, #bcpo .bcpo-front-image-label, #bcpo .bcpo-front-color-label, #bcpo .bcpo-front-image-option, #bcpo .bcpo-front-color-option, #bcpo input, #bcpo label');
      if (bcpoColorTarget && isBcpoColorTarget(bcpoColorTarget)) {
        scheduleBcpoColorImageUpdate(bcpoColorTarget);
      }
    }, true);

    root.addEventListener('change', (event) => {
      const liftInput = event.target && event.target.closest ? event.target.closest('[data-fd-lift-input]') : null;
      if (liftInput) {
        updateCordedControls(liftInput.value);
      }

      const voTemplateControl = event.target && event.target.closest ? event.target.closest('[data-fd-vo-sync]') : null;
      if (voTemplateControl) {
        clearValidationState();
        syncTemplateRadioGroup(voTemplateControl);
        syncTemplateControlToVo(voTemplateControl);
      }

      if (event.target === quantityInput && quantityInput) {
        quantityInput.value = String(Math.max(Number(quantityInput.value || 1), 1));
      }

      const bcpoInput = event.target && event.target.closest ? event.target.closest('#bcpo input, #bcpo .bcpo-front-image-option, #bcpo .bcpo-front-color-option') : null;
      if (bcpoInput && isBcpoColorTarget(bcpoInput)) {
        clearValidationState();
        scheduleBcpoColorImageUpdate(bcpoInput);
      }
    });

    root.addEventListener('input', (event) => {
      const voTemplateControl = event.target && event.target.closest ? event.target.closest('[data-fd-vo-sync]') : null;
      if (!voTemplateControl || !/^(number|text|search|tel|url|email)?$/i.test(voTemplateControl.type || '')) return;
      clearValidationState();
      window.clearTimeout(voTemplateControl.fdVoSyncTimer);
      voTemplateControl.fdVoSyncTimer = window.setTimeout(() => {
        syncTemplateControlToVo(voTemplateControl);
      }, 200);
    });

    document.addEventListener('change', (event) => {
      const target = event.target && event.target.closest ? event.target : null;
      if (!target) return;
      const bcpoInput = target.closest('#bcpo input, #bcpo .bcpo-front-image-option, #bcpo .bcpo-front-color-option');
      if (bcpoInput && isBcpoColorTarget(bcpoInput)) {
        clearValidationState();
        scheduleBcpoColorImageUpdate(bcpoInput);
      }
    }, true);

    thumbs.forEach((thumb) => {
      if (thumb.classList.contains('is-active')) activateThumb(thumb);
    });
    initMobileGallerySwipe();

    const checkedLift = root.querySelector('[data-fd-lift-input]:checked');
    if (checkedLift) {
      updateCordedControls(checkedLift.value);
    }

    const initialColor = root.querySelector('.fd-pdp-option--color:not([hidden]) [data-fd-option-value].is-selected');
    if (initialColor) {
      updateGalleryGroup(initialColor.dataset.valueHandle, initialColor.dataset.image);
    }

    if (window.location.hash) {
      const initialTab = pdpTabs.find((tab) => tab.getAttribute('href') === window.location.hash);
      if (initialTab) window.setTimeout(() => activateDetailTab(initialTab, false), 300);
    }

    const syncSelectedBcpoColor = () => {
      applyForceHiddenBcpoOptions();
      decorateBcpoColorOptions();
      refreshDuplicateThemeColorOptions();
      refreshVoTemplate();
      const selectedBcpoColor = Array.from(document.querySelectorAll('#bcpo input:checked')).find((input) => isBcpoColorTarget(input));
      if (selectedBcpoColor) updateBcpoColorImage(selectedBcpoColor);
    };
    window.setTimeout(syncSelectedBcpoColor, 600);
    window.setTimeout(syncSelectedBcpoColor, 1800);
    window.setTimeout(syncSelectedBcpoColor, 3200);
    if (window.MutationObserver) {
      let decorateFrame = 0;
      const scheduleDecorate = () => {
        if (decorateFrame) return;
        decorateFrame = window.requestAnimationFrame(() => {
          decorateFrame = 0;
          applyForceHiddenBcpoOptions();
          decorateBcpoColorOptions();
          refreshDuplicateThemeColorOptions();
          refreshVoTemplate();
          enforceTargetBcpoMainImage();
        });
      };
      const observer = new MutationObserver(scheduleDecorate);
      observer.observe(root, { childList: true, subtree: true });
      if (document.body && document.body !== root) observer.observe(document.body, { childList: true, subtree: true });
      if (preferBcpoColorImageAsMain && mainImage) observer.observe(mainImage, { attributes: true, attributeFilter: ['src', 'srcset'] });
    }
  });
})();
